import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';

type TableSkeletonProps = {
  rows?: number;
  className?: string;
};

const TableSkeleton = ({ rows = 5, className }: TableSkeletonProps) => {
  return (
    <div className="my-1 grid w-full gap-y-3 rounded px-3 py-1">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton
          key={i}
          className={cn('h-14 w-full rounded-md vt-containers-settings-box-normal-bg', className)}
        />
      ))}
    </div>
  );
};

export default TableSkeleton;
